import { render, staticRenderFns } from "./MeetingroomView.vue?vue&type=template&id=a52a6c0e&scoped=true"
import script from "./MeetingroomView.vue?vue&type=script&lang=js"
export * from "./MeetingroomView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52a6c0e",
  null
  
)

export default component.exports